module.exports = __webpack_public_path__ + "img/3.82b9a13b.png";